import { components } from "./api";

export const getCelcius = (temp: null | undefined | components["schemas"]["Temperature"]) => {
    if (temp && 'C' in temp) return temp.C;
    return null;
}

export const getmmHeightInterval = (xyxy: null | undefined | components["schemas"]["HeightAmmount"]) => {
    if (xyxy && 'MillimetersInterval' in xyxy) return xyxy.MillimetersInterval;
    return null;
}
export const getcmHeightInterval = (xyxy: null | undefined | components["schemas"]["HeightAmmount"]) => {
    if (xyxy && 'CentimetersInterval' in xyxy) return xyxy.CentimetersInterval;
    return null;
}